<template>
  <promo-codes/>
</template>

<script>
import PromoCodes from  '../finance/PromoCodes.vue'
export default {
  components: {
    PromoCodes
  }
}
</script>